import { useContext, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../auth/ContextAuthentication";

const useAxiosConfig = () => {
  const { clearSession } = useContext(AuthContext);
  const navigate = useNavigate();

  return useMemo(() => {
    const axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      timeout: 15000,
      maxBodyLength: 10 * 1024 * 1024,
      maxContentLength: 10 * 1024 * 1024,
      headers: {
        "Content-Type": "application/json",
      },
    });

    axiosInstance.interceptors.request.use((config) => {
      const bearerToken = localStorage.getItem("access_token");
      if (bearerToken) {
        config.headers.Authorization = `Bearer ${bearerToken}`;
      }
      return config;
    });

    axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          clearSession();
          navigate("/login", { replace: true });
        }
        return Promise.reject(error);
      }
    );

    return axiosInstance;
  }, [clearSession, navigate]);
};

export default useAxiosConfig;
